import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCross = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.24502 6L12.245 11L17.245 6L18.6592 7.41421L13.6592 12.4142L18.6592 17.4142L17.245 18.8284L12.245 13.8284L7.24502 18.8284L5.83081 17.4142L10.8308 12.4142L5.83081 7.41421L7.24502 6Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCross);
export { ForwardRef as ReactComponent };
